import { type FC, Fragment } from 'preact/compat';

import { Text } from '@vkontakte/vkui';

import { isLinkValid, parseTextWithLink } from '../../utils';

import styles from './styles.module.css';

interface Props {
  text: string;
  className?: string;
}

export const TextWithLink: FC<Props> = ({ text, className }) => {
  const parts = parseTextWithLink(text);

  return (
    <Text className={className}>
      {parts.map((part, index) => {
        if (index % 2 === 1) {
          const isValid = isLinkValid(part);

          if (isValid) {
            return (
              <a key={index} className={styles.messageLink} target={'_blank'} rel="noopener noreferrer" href={part}>
                {part}
              </a>
            );
          }
        }

        return <Fragment key={index}>{part}</Fragment>;
      })}
    </Text>
  );
};
